var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiamond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 18,
    viewBox: "0 0 26 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.159807 5.43946H25.7518C25.7544 5.43946 25.7569 5.4398 25.7582 5.43946C25.8465 5.43946 25.9181 5.36192 25.9181 5.26639C25.9181 5.21966 25.9009 5.17709 25.873 5.14594L23.2921 0.0893017C23.2639 0.0342668 23.2102 0 23.152 0H2.75963C2.70141 0 2.64767 0.0342668 2.61952 0.0893017L0.0200108 5.18263C-0.0075006 5.23628 -0.00654091 5.30135 0.0222501 5.35431C0.0510411 5.40727 0.103185 5.43946 0.159807 5.43946Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7582 5.34839H0.160044C0.0941283 5.34839 0.0349326 5.38871 0.0109343 5.45046C-0.0130639 5.5119 0.00325483 5.58165 0.0518913 5.62645L12.851 17.3677C12.8817 17.3958 12.9204 17.4099 12.9591 17.4099C12.9978 17.4099 13.0366 17.3958 13.0673 17.3677L25.8664 5.62645C25.915 5.58165 25.9313 5.5119 25.9073 5.45046C25.8836 5.38871 25.8238 5.34839 25.7582 5.34839Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.706652aedcb7b6b200a4bd7372d2002a.svg";
export { ForwardRef as ReactComponent };